import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import Avatar from '#components/a/Avatar'
import IconButton from '#components/a/IconButton'
import Api from '#services/api'
import NoticeModal from '#components/m/NoticeModal'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'
import {MailToAusbilder} from '#components/m/MeineAzubis/MailToAusbilder'
import AusbildungsnachweisCell from '#components/m/MeineAzubis/AusbildungsnachweisCell'
import AusbildungsjahrCell from '#components/m/MeineAzubis/AusbildungsjahrCell'
import {AusbildungsberufCell} from '#components/m/MeineAzubis/AusbildungsberufCell'

export class AzubiRow extends React.Component {
  handleAzubiNote = async (azubiId, note) => {
    try {
      await Api.createNote(azubiId, note)
    } catch (error) {
      actions.error.writeError({error})
    }
  }

  render() {
    const {permissions, azubi, updateParentState, reloadAzubis} = this.props

    const showUserIds = permissions.meineAzubis.viewUserIds
    const formattedUserId = showUserIds ? `[${azubi.id}]` : ''

    return (
      <tr>
        <td>
          <div>
            <Avatar profileImage={azubi.profileImage} />
            <TriggerWithTooltip
              text={`${azubi.lastname}, ${azubi.firstname} ${formattedUserId}`}
              modifiers={['dark', 'nopadding']}>
              <span className="primary">{`${azubi.lastname}, ${azubi.firstname}`}</span>
              {showUserIds && (
                <span data-testid="azubiId" className="secondary">
                  {formattedUserId}
                </span>
              )}
            </TriggerWithTooltip>
          </div>
        </td>
        <td>
          <AusbildungsberufCell azubi={azubi} />
        </td>
        <td>
          <div>
            <TriggerWithTooltip text={azubi.markt} modifiers={['dark', 'nopadding']}>
              <span>{azubi.markt}</span>
            </TriggerWithTooltip>
          </div>
        </td>
        <td>
          <div>
            <span>{azubi.ausbildungsstartFormatted}</span>
          </div>
        </td>
        <td>
          <AusbildungsjahrCell
            azubi={azubi}
            reloadAzubis={reloadAzubis}
            canChangeAusbildungsjahr={permissions.meineAzubis.changeAusbildungsjahr}
          />
        </td>
        <td>
          <AusbildungsnachweisCell
            azubi={azubi}
            reloadAzubis={reloadAzubis}
            canChangeAusbildungsnachweistyp={permissions.meineAzubis.changeAusbildungsnachweistyp}
          />
        </td>
        {permissions.meineAzubis.sendMailToAusbilder && (
          <td>
            <MailToAusbilder
              getAusbilderEmailAddress={this.getAusbilderEmailAddress}
              onMailButtonClicked={this.onMailButtonClicked}
              updateParentState={updateParentState}
              azubi={azubi}
            />
          </td>
        )}
        <td>
          <NoticeModal
            id="azubi_notice_iconbutton"
            trigger={
              <TriggerWithTooltip
                text={i18n.t('meineazubis_azubinotice_tooltip')}
                placement="top"
                modifiers={['dark', 'nopadding']}>
                <div className="meineazubis__tablecell">
                  <IconButton icon="notice" />
                </div>
              </TriggerWithTooltip>
            }
            lastname={azubi.lastname}
            firstname={azubi.firstname}
            confirmCallback={noteText => this.handleAzubiNote(azubi.id, noteText)}
            commentNote={azubi.note}
          />
        </td>
      </tr>
    )
  }
}

AzubiRow.propTypes = {
  permissions: PropTypes.object.isRequired,
  azubi: PropTypes.object.isRequired,
  updateParentState: PropTypes.func.isRequired,
  reloadAzubis: PropTypes.func,
}

const mapStateToProps = state => ({
  permissions: state.authentication.permissions,
})

export default connect(mapStateToProps)(AzubiRow)
